import { forwardRef } from 'react';
import classNames from 'classnames';

import { InputProps } from './input-text.types';

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      hasError,
      type = 'text',
      readOnly,
      disabled,
      showBorder = true,
      cursorClassName,
      paddingLeftClassName = 'pl-2',
      className = '',
      isChangingInactiveColor = true,
      widthClassName = 'w-full',
      helperText,
      prefix,
      ...props
    },
    ref
  ) => {
    const cursorInput = cursorClassName ?? 'cursor-default';
    const isActive = !readOnly && !disabled;
    return (
      <div className='flex flex-col'>
        <div className='relative flex items-center w-full'>
          {prefix && <span className='absolute left-2 text-gray-500'>{prefix}</span>}
          <input
            readOnly={readOnly}
            ref={ref}
            className={classNames(
              'text-body-m focus:text-subtitle-m',
              'placeholder:text-secondary placeholder:text-body-m fill-primary focus:fill-primary',
              'rounded-md',
              {
                'border-soft focus:border-hard hover:border-hard': !hasError,
                'border-critical-soft focus:border-critical-soft hover:border-critical-soft': hasError,
                'cursor-not-allowed border-soft': !isActive,
                'text-tertiary': !isActive && isChangingInactiveColor,
                'text-primary': isActive || (!isActive && !isChangingInactiveColor),
                'border-0': !showBorder,
                'border ': showBorder,
              },
              `${cursorInput} ${className} ${widthClassName} p-3 focus:outline-none focus:ring-0`,
              prefix ? 'pl-10' : paddingLeftClassName // Adjust padding when prefix is present
            )}
            type={type}
            {...props}
          />
        </div>
        {helperText && <p className='mt-1 text-xs text-secondary'>{helperText}</p>}
      </div>
    );
  }
);
